import Vehicle from "../services/vehicles.js"

function valida(val, args){
  if(!val)
    return true;

  let len = val.toString().replace("-", '').length;

  //nao valida
  if(len != 7)
    return true;

  return Vehicle.vehicleNotExists(val).then(r => {return {valid: r}});
}

function validaFormato(val, args){
  if(!val)
    return false;

  let len = val.toString().replace("-", '').length;

  if(len != 7)
    return false;

  return true;
}

export const plateExist = {
  messages: {
    en: (field, args) => {
      return "Veículo já cadastrado";
    },
    'pt-BR': (field, args) => {
      return "Veículo já cadastrado";
    }
  },
  validate(value, args) {
    return valida(value, args);
  }
};

export const plateValid = {
  messages: {
    en: (field, args) => {
      return "Placa inválida";
    },
    'pt-BR': (field, args) => {
      return "Placa inválida";
    }
  },
  validate(value, args) {
    return validaFormato(value, args);
  }
};



// WEBPACK FOOTER //
// ./src/validators/plate.js